(function () {
  'use strict';

  function initCart(sectionEl) {
    var sectionId = sectionEl.dataset.sectionId;

    // ── Qty steppers ──────────────────────────────────
    sectionEl.querySelectorAll('.product_qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key    = btn.dataset.key;
        var input  = sectionEl.querySelector('.product_qty-input[data-key="' + key + '"]');
        if (!input) return;
        var val = parseInt(input.value, 10) || 1;
        var max = parseInt(btn.dataset.max, 10);
        if (btn.dataset.action === 'increment') {
          // Cap at the line's stock — /cart/update does not enforce inventory
          var next = val + 1;
          if (!isNaN(max)) next = Math.min(next, max);
          if (next === val) return;
          input.value = next;
        } else if (btn.dataset.action === 'decrement') {
          input.value = Math.max(0, val - 1);
        }
        // Submit form so Shopify processes the update
        var form = sectionEl.querySelector('#CartForm-' + sectionId);
        if (form) form.submit();
      });
    });

    // A typed value bypasses the stepper, so clamp it against the same max
    sectionEl.querySelectorAll('.product_qty-input[max]').forEach(function (input) {
      input.addEventListener('change', function () {
        var max = parseInt(input.getAttribute('max'), 10);
        var val = parseInt(input.value, 10);
        if (isNaN(val) || val < 0) val = 0;
        if (!isNaN(max) && val > max) val = max;
        input.value = val;
      });
    });

    // ── Discount code ─────────────────────────────────
    // Shopify has no storefront API for applying a code to the cart, so we
    // hand off to /discount/CODE, which applies it to the session and
    // redirects back to the cart.
    var couponForm = sectionEl.querySelector('[data-cart-coupon]');
    if (couponForm) {
      couponForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = couponForm.querySelector('.cart_coupon-input');
        var error = sectionEl.querySelector('.cart_coupon-error');
        var code  = input ? input.value.trim() : '';

        if (!code) {
          if (error) error.hidden = false;
          if (input) input.focus();
          return;
        }
        if (error) error.hidden = true;

        window.location.href =
          '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
      });
    }

    // ── Order note accordion (jQuery slide) ──────────────────────────
    var toggle = document.getElementById('CartNoteToggle-' + sectionId);
    var body   = document.getElementById('CartNoteBody-' + sectionId);
    var $      = window.jQuery;

    if (toggle && body && $) {
      var $body = $(body);
      $(toggle).on('click', function (e) {
        e.preventDefault();
        var willExpand = !$body.is(':visible');
        toggle.setAttribute('aria-expanded', String(willExpand));
        body.setAttribute('aria-hidden', String(!willExpand));
        $body.slideToggle(300);
      });

      $(toggle).on('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          $(toggle).trigger('click');
        }
      });
    }
  }

  function runInit() {
    document.querySelectorAll('.main-cart[data-section-id]').forEach(function (el) {
      initCart(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInit);
  } else {
    runInit();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sectionEl = e.target.querySelector ? e.target.querySelector('.main-cart[data-section-id]') : null;
    if (sectionEl) initCart(sectionEl);
  });

})();
